import React from "react";

/**
 * Simple section header — no numbered pagination badge.
 * Big navy heading with a yellow underline segment.
 */
export const SectionHeader = ({ kicker, title, subtitle, tone = "navy", align = "left", className = "" }) => {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  const titleColor = tone === "light" ? "text-white" : "text-[color:var(--ge-navy)]";
  const kickerColor = tone === "light" ? "text-white/70" : "text-[color:var(--ge-navy)]/70";
  const subColor = tone === "light" ? "text-white/85" : "text-[color:var(--ge-navy)]/85";
  return (
    <div className={`flex flex-col ${alignCls} ${className}`}>
      {kicker && (
        <div className={`text-[11px] uppercase tracking-[0.32em] font-semibold ${kickerColor}`}>
          {kicker}
        </div>
      )}
      <h2 className={`mt-3 display-font tight-cap font-extrabold leading-[1.02] text-[clamp(2.2rem,5.2vw,4.4rem)] ${titleColor}`}>
        {title}
      </h2>
      <div className="mt-5 h-[4px] w-14 rounded-full" style={{ background: "var(--ge-yellow)" }} aria-hidden />
      {subtitle && (
        <p className={`mt-6 max-w-2xl text-base md:text-lg font-light leading-relaxed ${subColor}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
